export const INITIAL_STATE_PURCHASE = {
  id: "",
  idFornecedor: "",
  dataCompra: "",
  numeroNfe: "",
  modeloNfe: "",
  serieNfe: "",
  dadosAdicionais: null,
  quantidade: 1,
  valorUnitario: 0,
  cfop: "",
  baseIcms: "0.00",
  vIcms: "0.00",
  vIpi: "0.00",
  vOutros: "0.00",
  idNatureOp: "",
  chaveNfe: null,
  valorNfe: 0,
}

export const INVALID_FIELDS_PURCHASE = {
  idFornecedor: "",
  dataCompra: "",
}